import { __decorate, __param } from 'tslib';
import { EventEmitter, Inject, ViewChild, Input, Output, Component, ChangeDetectionStrategy, NgModule } from '@angular/core';
import { AbstractTuiInteractive, isNativeFocused, tuiDefaultProp, TuiFocusVisibleModule, TuiFocusedModule, TuiFocusableModule, TuiPreventDefaultModule } from '@taiga-ui/cdk';
import { TUI_SPIN_TEXTS } from '@taiga-ui/core/tokens';
import { Observable } from 'rxjs';
import { CommonModule } from '@angular/common';
import { TuiButtonModule } from '@taiga-ui/core/components/button';

// @dynamic
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@taiga-ui/cdk';
import * as ɵngcc3 from '@taiga-ui/core/components/button';
import * as ɵngcc4 from 'rxjs';

const _c0 = ["wrapper"];
function TuiPrimitiveSpinButtonComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1, 2);
    ɵngcc0.ɵɵlistener("tuiFocusedChange", function TuiPrimitiveSpinButtonComponent_div_0_Template_div_tuiFocusedChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.onFocused($event); })("tuiFocusVisibleChange", function TuiPrimitiveSpinButtonComponent_div_0_Template_div_tuiFocusVisibleChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.onFocusVisible($event); })("keydown.arrowLeft", function TuiPrimitiveSpinButtonComponent_div_0_Template_div_keydown_arrowLeft_0_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.onLeftClick(); })("keydown.arrowRight", function TuiPrimitiveSpinButtonComponent_div_0_Template_div_keydown_arrowRight_0_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.onRightClick(); });
    ɵngcc0.ɵɵelementStart(2, "button", 3);
    ɵngcc0.ɵɵlistener("click", function TuiPrimitiveSpinButtonComponent_div_0_Template_button_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.onLeftClick(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "span", 4);
    ɵngcc0.ɵɵprojection(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "button", 5);
    ɵngcc0.ɵɵlistener("click", function TuiPrimitiveSpinButtonComponent_div_0_Template_button_click_5_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.onRightClick(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const texts_r1 = ctx.ngIf;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("tuiFocusable", ctx_r0.computedFocusable);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵclassProp("arrow_hidden", ctx_r0.leftComputedDisabled);
    ɵngcc0.ɵɵproperty("title", texts_r1[0])("focusable", false);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵclassProp("arrow_hidden", ctx_r0.rightComputedDisabled);
    ɵngcc0.ɵɵproperty("title", texts_r1[1])("focusable", false);
} }
const _c1 = ["*"];
let TuiPrimitiveSpinButtonComponent = class TuiPrimitiveSpinButtonComponent extends AbstractTuiInteractive {
    constructor(spinTexts$) {
        super();
        this.spinTexts$ = spinTexts$;
        this.disabled = false;
        this.mode = "flat" /* Flat */;
        this.leftDisabled = false;
        this.rightDisabled = false;
        this.leftClick = new EventEmitter();
        this.rightClick = new EventEmitter();
    }
    get focused() {
        return !!this.wrapper && isNativeFocused(this.wrapper.nativeElement);
    }
    get leftComputedDisabled() {
        return this.computedDisabled || this.leftDisabled;
    }
    get rightComputedDisabled() {
        return this.computedDisabled || this.rightDisabled;
    }
    onLeftClick() {
        if (!this.leftComputedDisabled) {
            this.leftClick.emit();
        }
    }
    onRightClick() {
        if (!this.rightComputedDisabled) {
            this.rightClick.emit();
        }
    }
    onFocused(focused) {
        this.updateFocused(focused);
    }
    onFocusVisible(focusVisible) {
        this.updateFocusVisible(focusVisible);
    }
};
TuiPrimitiveSpinButtonComponent.ɵfac = function TuiPrimitiveSpinButtonComponent_Factory(t) { return new (t || TuiPrimitiveSpinButtonComponent)(ɵngcc0.ɵɵdirectiveInject(TUI_SPIN_TEXTS)); };
TuiPrimitiveSpinButtonComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TuiPrimitiveSpinButtonComponent, selectors: [["tui-primitive-spin-button"]], viewQuery: function TuiPrimitiveSpinButtonComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.wrapper = _t.first);
    } }, inputs: { disabled: "disabled", mode: "mode", leftDisabled: "leftDisabled", rightDisabled: "rightDisabled" }, outputs: { leftClick: "leftClick", rightClick: "rightClick" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c1, decls: 2, vars: 3, consts: [["tuiPreventDefault", "mousedown", "class", "wrapper", 3, "tuiFocusable", "tuiFocusedChange", "tuiFocusVisibleChange", "keydown.arrowLeft", "keydown.arrowRight", 4, "ngIf"], ["tuiPreventDefault", "mousedown", 1, "wrapper", 3, "tuiFocusable", "tuiFocusedChange", "tuiFocusVisibleChange", "keydown.arrowLeft", "keydown.arrowRight"], ["wrapper", ""], ["tuiIconButton", "", "type", "button", "size", "xs", "appearance", "", "automation-id", "tui-primitive-spin-button__left", "icon", "tuiIconChevronLeftLarge", 1, "arrow", 3, "title", "focusable", "click"], [1, "content"], ["tuiIconButton", "", "type", "button", "size", "xs", "appearance", "", "automation-id", "tui-primitive-spin-button__right", "icon", "tuiIconChevronRightLarge", 1, "arrow", 3, "title", "focusable", "click"]], template: function TuiPrimitiveSpinButtonComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, TuiPrimitiveSpinButtonComponent_div_0_Template, 6, 9, "div", 0);
        ɵngcc0.ɵɵpipe(1, "async");
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(1, 1, ctx.spinTexts$));
    } }, directives: [ɵngcc1.NgIf, ɵngcc2.TuiPreventDefaultDirective, ɵngcc2.TuiFocusableDirective, ɵngcc2.TuiFocusedDirective, ɵngcc2.TuiFocusVisibleDirective, ɵngcc3.TuiButtonComponent], pipes: [ɵngcc1.AsyncPipe], styles: ["[_nghost-%COMP%]{display:block;font:var(--tui-font-text-l);text-align:center;font-weight:700}.wrapper[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:space-between;outline:0}.arrow[_ngcontent-%COMP%]{margin:0 .25rem}.arrow_hidden[_ngcontent-%COMP%]{visibility:hidden}.content[_ngcontent-%COMP%]{padding:0 .5rem}._focus-visible[_nghost-%COMP%]   .content[_ngcontent-%COMP%]{box-shadow:0 0 0 1px var(--tui-focus)}"], changeDetection: 0 });
TuiPrimitiveSpinButtonComponent.ctorParameters = () => [
    { type: Observable, decorators: [{ type: Inject, args: [TUI_SPIN_TEXTS,] }] }
];
__decorate([
    ViewChild('wrapper')
], TuiPrimitiveSpinButtonComponent.prototype, "wrapper", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiPrimitiveSpinButtonComponent.prototype, "disabled", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiPrimitiveSpinButtonComponent.prototype, "mode", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiPrimitiveSpinButtonComponent.prototype, "leftDisabled", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiPrimitiveSpinButtonComponent.prototype, "rightDisabled", void 0);
__decorate([
    Output()
], TuiPrimitiveSpinButtonComponent.prototype, "leftClick", void 0);
__decorate([
    Output()
], TuiPrimitiveSpinButtonComponent.prototype, "rightClick", void 0);
TuiPrimitiveSpinButtonComponent = __decorate([ __param(0, Inject(TUI_SPIN_TEXTS))
], TuiPrimitiveSpinButtonComponent);

let TuiPrimitiveSpinButtonModule = class TuiPrimitiveSpinButtonModule {
};
TuiPrimitiveSpinButtonModule.ɵfac = function TuiPrimitiveSpinButtonModule_Factory(t) { return new (t || TuiPrimitiveSpinButtonModule)(); };
TuiPrimitiveSpinButtonModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: TuiPrimitiveSpinButtonModule });
TuiPrimitiveSpinButtonModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            TuiFocusVisibleModule,
            TuiFocusedModule,
            TuiFocusableModule,
            TuiPreventDefaultModule,
            TuiButtonModule,
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiPrimitiveSpinButtonComponent, [{
        type: Component,
        args: [{
                selector: 'tui-primitive-spin-button',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: "<div\n    *ngIf=\"spinTexts$ | async as texts\"\n    #wrapper\n    tuiPreventDefault=\"mousedown\"\n    class=\"wrapper\"\n    [tuiFocusable]=\"computedFocusable\"\n    (tuiFocusedChange)=\"onFocused($event)\"\n    (tuiFocusVisibleChange)=\"onFocusVisible($event)\"\n    (keydown.arrowLeft)=\"onLeftClick()\"\n    (keydown.arrowRight)=\"onRightClick()\"\n>\n    <button\n        tuiIconButton\n        type=\"button\"\n        size=\"xs\"\n        appearance=\"\"\n        automation-id=\"tui-primitive-spin-button__left\"\n        icon=\"tuiIconChevronLeftLarge\"\n        class=\"arrow\"\n        [class.arrow_hidden]=\"leftComputedDisabled\"\n        [title]=\"texts[0]\"\n        [focusable]=\"false\"\n        (click)=\"onLeftClick()\"\n    ></button>\n    <span class=\"content\">\n        <ng-content></ng-content>\n    </span>\n    <button\n        tuiIconButton\n        type=\"button\"\n        size=\"xs\"\n        appearance=\"\"\n        automation-id=\"tui-primitive-spin-button__right\"\n        icon=\"tuiIconChevronRightLarge\"\n        class=\"arrow\"\n        [class.arrow_hidden]=\"rightComputedDisabled\"\n        [title]=\"texts[1]\"\n        [focusable]=\"false\"\n        (click)=\"onRightClick()\"\n    ></button>\n</div>\n",
                styles: [":host{display:block;font:var(--tui-font-text-l);text-align:center;font-weight:700}.wrapper{display:flex;align-items:center;justify-content:space-between;outline:0}.arrow{margin:0 .25rem}.arrow_hidden{visibility:hidden}.content{padding:0 .5rem}:host._focus-visible .content{box-shadow:0 0 0 1px var(--tui-focus)}"]
            }]
    }], function () { return [{ type: ɵngcc4.Observable, decorators: [{
                type: Inject,
                args: [TUI_SPIN_TEXTS]
            }] }]; }, { disabled: [{
            type: Input
        }], mode: [{
            type: Input
        }], leftDisabled: [{
            type: Input
        }], rightDisabled: [{
            type: Input
        }], leftClick: [{
            type: Output
        }], rightClick: [{
            type: Output
        }], wrapper: [{
            type: ViewChild,
            args: ['wrapper']
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiPrimitiveSpinButtonModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    TuiFocusVisibleModule,
                    TuiFocusedModule,
                    TuiFocusableModule,
                    TuiPreventDefaultModule,
                    TuiButtonModule,
                ],
                declarations: [TuiPrimitiveSpinButtonComponent],
                exports: [TuiPrimitiveSpinButtonComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TuiPrimitiveSpinButtonModule, { declarations: function () { return [TuiPrimitiveSpinButtonComponent]; }, imports: function () { return [CommonModule,
        TuiFocusVisibleModule,
        TuiFocusedModule,
        TuiFocusableModule,
        TuiPreventDefaultModule,
        TuiButtonModule]; }, exports: function () { return [TuiPrimitiveSpinButtonComponent]; } }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { TuiPrimitiveSpinButtonComponent, TuiPrimitiveSpinButtonModule };

